export const promptForRephraseMessageBasedOnConversation = (conversation,enteredMessage) => {
  return `Rephrase this message ONLY if it is meaningful: "${enteredMessage}".
If it's not meaningful, return it exactly as is.
Do NOT add any explanation. Do NOT say whether it is meaningful or not.
Do NOT include anything other than the message itself.
If emojis are present, keep them. Respond in the **same language** used in the conversation.`
}

export const promptForSuggestReply = (conversation) => {
  return `Here is the recent conversation:\n${conversation}\n\nBased on the recent conversation, generate a helpful and context-aware message **as the Agent**.Speak from the Agent’s point of view. ONLY return the message without any additional text. Respond in the **same language** used in the conversation.`
}

export const promptForNormalGreetingMessage = () => {
    return `Generate a default greeting message. ONLY return the reply message.`
}

export const promptForRephraseMessage = (enteredMessage) => {
    return `Check if this sentence is meaningful: ${enteredMessage}.  
If meaningful Rephrase the following reply message: "${enteredMessage}". ONLY return the rephrased message without any additional text ,explanations or formatting.If emojis are present, keep them in the message. If not meaningful, return the message exactly as it is don't add any explanation: ${enteredMessage}. Respond in the **same language** used in the conversation.`;
}

export const promptForCreateMessageTemplate = (message) => {
  return `Rephrase the following CRM-related business communication message into a, single-line sentence using natural phrasing. 
If the message is not meaningful or incomplete, return it exactly as is without any explanation.
Keep any emojis present and avoid using placeholders like [Customer Name] or [User Name].
Message and also include the fields in the message: "${message}". Only return the final sentence. Do not include any explanations, prefixes, or additional commentary.`;
};
